import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';

import '../../assets/css/CollectionMainInfoPageVer.css'

import { AND, OR, NOT } from '../../config';
import Footer from "../../components/Footer";
import CollectionMaininfoPageCell from "../../components/CollectionMaininfoPageCell";

import TFAILogoMain from '../../assets/images/TFAI-logo-main.svg'
import bgPic4 from '../../assets/images/pic-sCR04b.jpg'

const Df = () => {
    const searchWord = localStorage.getItem('keyWord')// 查詢關鍵字
    const itemData = JSON.parse(localStorage.getItem('itemData'));
    const printPageRef = useRef();
    
    const wordArray = searchWord.split(new RegExp(`(${AND}|${OR}|${NOT})`, 'i'))
    let skipNext = false
    const searchArray = wordArray.filter((element) => {
        if (element === '' || element === AND || element === OR || skipNext) {
          skipNext = false;
          return false;
        } else if (element === NOT) {
          skipNext = true;
          return false;
        }
        return true;
    });

    // 判斷關鍵字是否需要添加 highlight 樣式
    const renderWithHighlight = (text) => {
        if (searchArray.length > 0 && text !== null) {
          const sortedArray = searchArray.sort((a, b) => b.length - a.length);
          const regex = new RegExp(sortedArray.join('|'), 'gi');
          // Matches array needed to maintain the correct letter casing
          const matches = [...text.matchAll(regex)];
          return text.split(regex).map((part, index) => (
            `${part}${index<matches.length ? `<div key={index} style="background-color: rgb(255, 255, 94); color: black; display: math;">${matches[index]}</div>` : ''}`
          )).join('');
        }
        return text;
    };
    
    const conditionCheck = (value)=>{        
        if(value){
            let target = value.replace(/\s/g,"")
            if(target === '' || target === '無標註'){
                return false
            } else{
                return true
            }
        } else{
            return false
        }
    }

    const createIDInfo = (print) => {
        return itemData && conditionCheck(itemData.原始藏品編號) ? 
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">
                    <div className="CollectionMainInfoRow" style={{display:'flex'}}>                                            
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"數位檔案識別碼 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.原始藏品編號) }} />
                        </div>
                    </div>
                </div>
            </div>
        :null
    }
    const createKeywordInfo = (print) => {
        return itemData && conditionCheck(getDFKeyword()) ?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer" style={{display:'flex'}}>
                    <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"關鍵字 "}</div>
                    <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                        <CollectionMaininfoPageCell>
                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(getDFKeyword()) }} />
                        </CollectionMaininfoPageCell>
                    </div>
                </div>
            </div>
        :null
    }
    const createSummary = (print) => {
        return itemData && (conditionCheck(itemData.摘要))?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">
                {conditionCheck(itemData.摘要)? 
                    <div className="CollectionMainInfoAreaPageVer" style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"摘要 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <CollectionMaininfoPageCell>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.摘要) }} />
                            </CollectionMaininfoPageCell>
                        </div>
                    </div>
                :null}           
                </div>
            </div>
        :null
    }
    const createContributor = (print) => {
        return itemData && itemData['職員表/製作資訊']?
            <div className="CollectionMainInfoMajorArea">
                {getDFStaff()}           
            </div>
        :null
    }
    const createDateInfo = (print) => {
        return itemData && conditionCheck(itemData.事件時間) ?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">       
                    <div className="CollectionMainInfoRow" style={{display:'flex'}}>                 
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>
                            { "事件時間 "}
                        </div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.事件時間) }} />
                        </div>
                    </div>
                </div>              
            </div>
        :null
    }
    const createSpecInfo = (print) => {
        return itemData && (conditionCheck(itemData.規格)||conditionCheck(itemData.資料傳輸率)||conditionCheck(itemData.畫面尺寸)||conditionCheck(itemData.聲音採樣率)||conditionCheck(itemData.聲道)||conditionCheck(itemData.色彩)||conditionCheck(itemData.時間長度))?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData.規格) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"規格 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.規格) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.資料傳輸率) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"資料傳輸率 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.資料傳輸率) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.DF_Resolution) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"解析度 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.DF_Resolution) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.畫面尺寸) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"畫面尺寸 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.畫面尺寸) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.聲音採樣率) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"聲音採樣率 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.聲音採樣率) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.聲道) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"聲道 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.聲道) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.色彩) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"色彩 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.色彩) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.時間長度) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"時間長度 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>                                                        
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.時間長度) }} />
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createRelationInfo = (print) => {
        return itemData && (conditionCheck(itemData.實體識別碼)||conditionCheck(itemData.實體名稱))?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">
                    <div className="MovieRowTitle" >{"關聯"}</div>
                </div>
                {conditionCheck(itemData.實體識別碼) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"實體識別碼 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>                     
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.實體識別碼) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.實體名稱) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"實體名稱 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.實體名稱) }} />
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createGeoInfo = (print) => {
        return itemData && conditionCheck(itemData.事件涵蓋空間) ?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData.事件涵蓋空間) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"事件涵蓋空間 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.事件涵蓋空間) }} />
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }

    const getDFKeyword=()=>{
        let output = ''        
        if(itemData['主題(主要主題+次要主題)']){
            output = itemData['主題(主要主題+次要主題)']
        }
        if(itemData.關鍵字){
            if(output === ''){
                output = itemData.關鍵字
            }else{
                output = output+'；'+itemData.關鍵字
            }
        }
        if(itemData.事件人物團體){
            if(output === ''){
                output = itemData.事件人物團體
            }else{
                output = output+'；'+itemData.事件人物團體
            }
        }
        return output
    }

    const getDFStaff=()=>{
        let sArray = []
        let output = []
        if(itemData && itemData['職員表/製作資訊']){
            sArray = itemData['職員表/製作資訊'].split("；")
            output =sArray.map(staff => {
                let s2Array = staff.split("：")
                return ( 
                    <div className="CollectionMainInfoAreaPageVer">       
                       <div className="CollectionMainInfoRow" style={{display:'flex'}}>                 
                            <div className="CollectionMainInfoRowTitlePageVer" >{s2Array[0]+'  '}</div>
                            <div className="CollectionMainInfoRowContentPageVer" >
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(s2Array[1]) }} />
                            </div>
                        </div>
                    </div>
                )
            });
        }
        return output
    }
        
    const createMedia=()=>{
        return (
            <div>
            {itemData && itemData.原始藏品編號 ?                        
                <div>
                    <div>
                        <iframe title="dfsrc" style={{width:'100%',height:'300px'}}
                            src={'https://vcenter.iis.sinica.edu.tw/videojs/watch_frame_for_digitalarchives.php?id='+itemData.原始藏品編號+'&fn='+itemData.原始藏品編號} allowFullScreen>
                        </iframe>
                    </div>
                    <div>{"#影片撥放需等候5~10秒載入，請耐心等候"}</div>
                </div>
                : null
            }
            </div>
        )
    }

    const getTime = () => {
        let d = new Date()
        return d.toLocaleString()
    }

    return (<>
        <div className="TFAI-box">
            <div id="content-bg">
                <aside></aside>
                <div className="ctn-pic"><img alt="headPic" src={bgPic4} /></div>
            </div>
            <div className="container-xl">
                <div className="ctn-header">
                    <div className="ctn-logo d-none d-lg-block">
                        <Link to="/"><img src={TFAILogoMain} alt="TFAI logo" className="img-fluid"/></Link>
                    </div>
                    <div className="ctn-heading">
                        <h1><span>新聞片藏品</span></h1>
                    </div>
                </div>
                <div className="ctn-area">
                    <div className="data-header row">  
                        <div className="col-12 col-md-7 col-lg-6">
                            <h2><div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.標題) }} /></h2>
                        </div>
                        <div className="col-12 col-md-5 col-lg-4 d-flex align-items-end share-links">   
                            <div className="media-share">        
                                <ReactToPrint
                                    trigger={()=>                         
                                        <svg className="bi bi-printer-fill" viewBox="0 0 16 16">
                                            <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                                            <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                        </svg>
                                    }
                                    content={()=>printPageRef.current}
                                />  
                            </div>  
                        </div>
                    </div>
                    <div className="data-body row">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div >
                                {createIDInfo()}
                                {createKeywordInfo()}
                                {createSummary()}
                                {createContributor()}
                                {createDateInfo()}
                                {createSpecInfo()}
                                {createRelationInfo()}
                                {createGeoInfo()}
                            </div>
                        </div>
                        <div className="data-img col-12 col-md-5 col-lg-4 ">
                            {createMedia()}
                            <aside>
                                <span>典藏單位</span>
                                <p>國家電影及視聽文化中心</p>
                            </aside>
                            <aside>                            
                                <p style={{marginBottom:'2px',color:'black',fontWeight:'bolder'}}>
                                    藏品能否租借，本中心需視藏品狀態、有無權限等因素而評估，若需取用請填寫
                                    <a href="https://www.tfai.org.tw/downloads/rent">資料借出使用申請單</a>
                                    ，向本中心提出申請。
                                </p>
                            </aside>
                        </div>
                    </div>
                </div>
            </div> 

            <div style={{ display: "none" }}>
                <div className="CollectionMainInfoMainBodyPrintPage" ref={printPageRef}>
                    <div>
                        <div style={{display:'flex'}}>
                            <div style={{position:'relative',width:'220px'}}>
                                <div style={{position:'absolute',bottom:'0px',fontSize:'12px'}}>
                                    {"國家電影及視聽文化中心 藏品檢索系統"}
                                </div>
                            </div>
                            <div>
                                <img alt="logo" src={TFAILogoMain}/>
                            </div>
                        </div>
                    </div>
                    <div style={{display:'flex'}}>
                        <div style={{width:'98%', margin:'1vw 1vw 0 1vw', fontSize:'20px'}}>
                            <div className="CollectionMainTitle" style={{borderBottom:'1px solid gray'}}>
                                <div className="CollectionMainInfoRow">
                                    <div className="MovieTitle" style={{fontSize:'20px'}}>                                        
                                        <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.標題) }} />
                                    </div>
                                </div>
                                {conditionCheck(itemData.翻譯名稱) ?
                                    <div className="CollectionMainInfoRow">
                                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:'12px'}}>{"翻譯片名 "}</div>
                                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:'12px'}}>          
                                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.翻譯名稱) }} />
                                        </div>
                                    </div>
                                :null}
                            </div>
                        </div>
                    </div>
                    <div className="CollectionMainInfoTableBody">                 
                        <div className='CollectionMainInfoTableColumnPrint'>
                            <div >
                                {createIDInfo(true)}
                                {createKeywordInfo(true)}
                                {createSummary(true)}
                                {createContributor(true)}
                                {createDateInfo(true)}
                                {createSpecInfo(true)}
                                {createRelationInfo(true)}
                                {createGeoInfo(true)}
                            </div>           
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="MovieRowTitle" style={{fontSize:'14px'}}>{"管理權"}</div>
                            </div>
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="CollectionMainInfoRowTitlePageVer" style={{width:'100%',fontSize:'12px'}}>{"國家電影及視聽文化中心"}</div>
                            </div>
                        </div>
                    </div>
                    <div style={{float:'right',paddingBottom:'50px'}} >
                        <div>
                            <div style={{display:'flex',fontSize:'12px'}}>
                                <div>列印時間 ：</div>
                                <div>{getTime()}</div>
                            </div>
                        </div>                
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    </>)
};

export default Df;